module.exports = __webpack_public_path__ + "static/media/GoodExampleOptimized.841850e4.webp";